import { createStyles, makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles(
	theme =>
		createStyles({
			btnDefaultDisable: {
				alignItems: "center",
				display: "flex",
				justifyContent: "space-between",
				padding: "10px 0px"
			},
			menuItem: {
				alignItems: "center",
				display: "flex",
				justifyContent: "space-between",
				padding: "10px 0px",
				cursor: "pointer",
				fontSize: 16,
				"&:hover": {
					opacity: 0.7
				}
			},
			iconMenu: {
				display: "flex",
				alignItems: "center",
				fontSize: 16,
				color: theme.palette.primary.contrastText,
				"& > img": {
					width: 28,
					height: 28,
					marginRight: 10
				}
			}
		}),
	{
		name: "MenuItem",
		index: 1
	}
);

export default useStyles;
